<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <span><i class="fas fa-angle-right"></i></span>
      }

      @if (!status) {
        <span><i class="fas fa-angle-left"></i></span>
      }
    </div>
    <div class="sidebar-header">
      <h3>Exclusions</h3>
    </div>

    <ul class="list-unstyled components">

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="prop19">{{'NavMenu.ParentChild'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="inter-spousal">{{'NavMenu.InterSpousal'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="joint-tenancy">{{'NavMenu.JointTenancy'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="registered-domestic-partners">{{'NavMenu.Domestic'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="builders">{{'NavMenu.Builders'|translate}}</a>
      </li>
      <!--<li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-construction">{{'NavMenu.NewConstDisabled'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-construction">{{'NavMenu.Earthquake'|translate}}</a>
    </li>-->
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="solar">{{'NavMenu.Solar'|translate}}</a>
    </li>



  </ul>

</nav>
<div id="content">

  <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
  <i class="fas fa-align-left"></i>
  <span>Toggle Sidebar</span>
</button> -->
<router-outlet></router-outlet>
</div>


</div>
